import { useState } from "react";
import { Link } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Modal from "../../../components/modal/Modal";
import TableSped from "./Content/TableSped";
import FilterSped from "./Content/FilterSped";
import ModalAddSped from "./Content/ModalAddSped";
import ModalDownload from "./Content/ModalDownload";
//hooks
import usePermission from "../../../hooks/usePermission";
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
//context
import { useAppContext } from "../../../context/AppContext";

const Sped = () => {
  const { permissions } = useAppContext();
  usePermission("260");
  const [rows, setRows] = useState(10);
  const [first, setFirst] = useState(0);
  const [showTable, setShowTable] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [downloadData, setDownloadData] = useState(null);
  const [visibleDownload, setVisibleDownload] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const {
    ownersOptions,
    parcelOptions,
    loadingOwners,
    loadingParcelDescriptions,
  } = useOptionsSelect();

  const totalRecords = filteredData.length;

  const items = [
    {
      template: () => (
        <Link to={"/reports/sped"} className="p-breadcrumb-link">
          Relatório de SPED
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const handleFilter = (data) => {
    setFilteredData(data);
    setFirst(0);
  };

  const handlePageChange = (e) => {
    setFirst(e.first);
    setRows(e.rows);
  };

  const handleSuccessGenerate = (data) => {
    setDownloadData(data);
    setVisibleDownload(true);
    setShowModal(false);
  };

  return (
    <>
      <div className="row mb-3">
        <div className="col-md-9 d-flex align-items-center">
          <BreadCrumb
            model={items}
            home={home}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
            }}
          />
        </div>
        <div className="col-md-3 d-flex justify-content-end align-items-center">
          {permissions.includes("261") && (
              <Button
                rounded
                severity="success"
                label="Gerar SPED"
                icon="fa fa-plus"
                className="p-inputtext-sm me-2 m-auto w-100"
                onClick={() => setShowModal(true)}
              />
            )}
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <FilterSped
            onFilter={handleFilter}
            setShowTable={setShowTable}
            ownersOptions={ownersOptions}
            parcelOptions={parcelOptions}
            loadingOwners={loadingOwners}
            loadingParcelDescriptions={loadingParcelDescriptions}
          />
        </div>
        {showTable && (
          <div className="col-md-12 mt-4">
            <TableSped
              first={first}
              rows={rows}
              data={filteredData}
              totalRecords={totalRecords}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>

      <Modal
        visible={showModal}
        dynamicTitle="Gerar relatório SPED"
        onHide={() => setShowModal(false)}
        dynamicWidth="60vw"
      >
        <ModalAddSped
          ownersOptions={ownersOptions}
          parcelOptions={parcelOptions}
          loadingOwners={loadingOwners}
          onSuccess={handleSuccessGenerate}
          onClose={() => setShowModal(false)}
          loadingParcelDescriptions={loadingParcelDescriptions}
        />
      </Modal>

      <ModalDownload
        rowData={downloadData}
        visible={visibleDownload}
        onHide={() => setVisibleDownload(false)}
      />
    </>
  );
};
export default Sped;
